
import React, { useState, useEffect } from 'react';
import MaxLoanList from './MaxLoanList';
import losData from '../hybriddata/loanstatusdata.json'
import { SingleFormLabel, SingleFormLabelBold } from '../validation/Form-Components';

const AAPNoProperty = (props) => {

    const {response, propertyData} = props;
 
    const [maxLoanNoPropList,setMaxLoanNoPropList] = useState([]);

    useEffect(() => {
        console.log('@FreeholdProperty useEffect');
        if(response.maxLoanDetailsNoProp && response.maxLoanDetailsNoProp !== null) {
            setMaxLoanNoPropList(response.maxLoanDetailsNoProp);
        }
    }, []);
   
    return(
        <div>
            <div className='pad-top10'>
                <SingleFormLabelBold labelId={'lblAIPtxt1'} 
                    labelName={(propertyData.PropertyInMind === 'Y')?losData.noProp.hasPropInMindTxt:losData.noProp.txt1} />
            </div>

            {(maxLoanNoPropList.length > 0) && 
                <MaxLoanList data={maxLoanNoPropList} />
            }

            <div className='pad-top10'>
                <SingleFormLabel labelId={'lblAIPtxt2'} 
                    labelName={losData.noProp.txt2} />
            </div>
        </div>
    )
}

export default AAPNoProperty;